export default __webpack_public_path__ + "static/media/home_content_6.24f235cc.png";